var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmoticonGreat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.9994 90C20.187 90 0 69.813 0 44.9994C0 20.1857 20.187 0 44.9994 0C69.8117 0 90 20.187 90 44.9994C90 69.8117 69.813 90 44.9994 90ZM44.9994 3.15664C21.9241 3.15664 3.15665 21.928 3.15665 44.9994C3.15665 68.0707 21.928 86.8382 44.9994 86.8382C68.0707 86.8382 86.8433 68.0668 86.8433 44.9942C86.8433 21.9215 68.072 3.15664 44.9994 3.15664Z",
    fill: "#717171"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.833 51.3081H66.0217C66.2238 51.3821 66.4085 51.4931 66.5652 51.6348C66.722 51.7764 66.8477 51.9459 66.9352 52.1336C67.0226 52.3213 67.0702 52.5234 67.075 52.7285C67.0799 52.9336 67.042 53.1376 66.9635 53.3288C63.4865 61.8094 55.0336 67.2894 45.4208 67.2894C35.808 67.2894 27.3617 61.8094 23.8846 53.3288C23.8063 53.1372 23.7687 52.9328 23.7741 52.7275C23.7794 52.5221 23.8275 52.3197 23.9156 52.132C24.0037 51.9443 24.1301 51.7748 24.2875 51.6335C24.445 51.4921 24.6304 51.3815 24.833 51.3081Z",
    fill: "#717171"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8663 35.7365C35.3614 32.7135 33.2902 29.8651 30.2401 29.3745C27.19 28.8838 24.3161 30.9366 23.821 33.9595C23.3259 36.9825 25.3971 39.8309 28.4472 40.3216C31.4973 40.8123 34.3712 38.7595 34.8663 35.7365Z",
    fill: "#717171"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5733 35.736C67.0684 32.713 64.9971 29.8647 61.9471 29.374C58.897 28.8833 56.023 30.9361 55.5279 33.959C55.0328 36.982 57.1041 39.8304 60.1541 40.3211C63.2042 40.8118 66.0782 38.759 66.5733 35.736Z",
    fill: "#717171"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoticonGreat);
export default __webpack_public_path__ + "static/media/emoticon_great.47fcf1193fa35d3b091c04a00139acdd.svg";
export { ForwardRef as ReactComponent };